// Slideshow Carousel Accessibility Fix
// 修复轮播图中 aria-selected 属性的无障碍访问问题
// 立即輸出，確保腳本已載入
console.log('🔍 Slideshow Accessibility Fix: Script loaded');

// ============================================
// 攔截 setAttribute 方法 - 必須在最開始執行
// ============================================
// 這是最根本的解決方案：在源頭阻止 aria-selected 的設置
// 必須在任何其他代碼之前執行，包括 Flickity 的初始化
(function interceptSetAttribute() {
  'use strict';
  
  // 保存原始的 setAttribute 方法
  const originalSetAttribute = Element.prototype.setAttribute;
  
  // 重寫 setAttribute 方法
  Element.prototype.setAttribute = function(name, value) {
    // 如果是 gallery-cell 且嘗試設置 aria-selected，則阻止
    if (this.classList && this.classList.contains('gallery-cell') && name === 'aria-selected') {
      console.log('🚫 Blocked aria-selected on gallery-cell:', this.className);
      // 不執行設置，直接返回
      return;
    }
    
    // 其他情況正常執行
    return originalSetAttribute.call(this, name, value);
  };
  
  console.log('✅ Intercepted setAttribute to prevent aria-selected on gallery-cell');
})();

// 確保在 DOM 準備好後執行
(function() {
  'use strict';
  
  console.log('TEST: Slideshow Accessibility Fix IIFE is executing');
  
  // 修復單個 gallery 的 ARIA 屬性
  function fixGalleryAccessibility(slideshow, slideshowType) {
    console.log('Processing ' + slideshowType);
    
    // 確保輪播圖容器有正確的 ARIA 屬性
    if (!slideshow.hasAttribute('role')) {
      slideshow.setAttribute('role', 'region');
      console.log('✅ Set role="region" on ' + slideshowType);
    }
    
    if (!slideshow.hasAttribute('aria-label')) {
      let ariaLabel = '';
      if (slideshow.classList.contains('js-homepage-slideshow')) {
        ariaLabel = 'Homepage banner carousel';
      } else if (slideshow.classList.contains('js-testimonial')) {
        ariaLabel = 'Testimonial carousel';
      } else if (slideshow.classList.contains('js-product-gallery')) {
        ariaLabel = 'Product image gallery';
      } else if (slideshow.classList.contains('product_gallery_nav')) {
        ariaLabel = 'Product thumbnail navigation';
      }
      if (ariaLabel) {
        slideshow.setAttribute('aria-label', ariaLabel);
        console.log('✅ Set aria-label on ' + slideshowType);
      }
    }
    
    // 查找所有輪播圖單元格
    const cells = slideshow.querySelectorAll('.gallery-cell');
      
      cells.forEach(function(cell, cellIndex) {
        // 移除 aria-selected 屬性（因為 div 不支持此屬性）
        if (cell.hasAttribute('aria-selected')) {
          cell.removeAttribute('aria-selected');
          console.log('✅ Removed aria-selected from cell #' + cellIndex);
        }
        
        // 檢查 Flickity 是否已初始化
        // 嘗試多種方式獲取 Flickity 實例
        let flickityInstance = null;
        if (typeof $ !== 'undefined' && $(slideshow).data) {
          flickityInstance = $(slideshow).data('flickity');
        }
        if (!flickityInstance && slideshow.flickity) {
          flickityInstance = slideshow.flickity;
        }
        
        let isHidden = false;
        
        // 檢查單元格是否被選中（通過 class 或 Flickity 實例）
        const isSelectedByClass = cell.classList.contains('is-selected');
        let isSelected = isSelectedByClass;
        
        if (flickityInstance && typeof flickityInstance.selectedIndex !== 'undefined') {
          // 根據 Flickity 的狀態設置 aria-hidden
          isSelected = flickityInstance.selectedIndex === cellIndex;
        } else if (!isSelectedByClass) {
          // 如果沒有 Flickity 實例，檢查是否是第一個單元格
          // 第一個單元格默認可見
          isSelected = cellIndex === 0;
        }
        
        isHidden = !isSelected;
        cell.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
        
        // 為選中的單元格添加 aria-current
        if (isSelected) {
          cell.setAttribute('aria-current', 'true');
        } else {
          cell.removeAttribute('aria-current');
        }
        
        // 處理 gallery-cell 元素本身的 tabindex
        // 當 aria-hidden="true" 時，元素本身不應該可聚焦
        const cellTabindex = cell.getAttribute('tabindex');
        if (isHidden) {
          // 如果單元格被隱藏，確保 tabindex="-1"
          if (!cell.hasAttribute('data-original-cell-tabindex')) {
            // 保存原始的 tabindex（如果存在且不是 "-1"）
            if (cellTabindex !== null && cellTabindex !== '-1') {
              cell.setAttribute('data-original-cell-tabindex', cellTabindex);
            } else {
              cell.setAttribute('data-original-cell-tabindex', '');
            }
          }
          if (cellTabindex !== '-1') {
            cell.setAttribute('tabindex', '-1');
            console.log('✅ Set tabindex="-1" on hidden gallery-cell #' + cellIndex);
          }
        } else {
          // 如果單元格可見，恢復原始的 tabindex
          if (cell.hasAttribute('data-original-cell-tabindex')) {
            const originalTabindex = cell.getAttribute('data-original-cell-tabindex');
            if (originalTabindex === '') {
              cell.removeAttribute('tabindex');
            } else {
              cell.setAttribute('tabindex', originalTabindex);
            }
            cell.removeAttribute('data-original-cell-tabindex');
            console.log('✅ Restored tabindex on visible gallery-cell #' + cellIndex);
          } else if (cellTabindex === '-1') {
            // 如果沒有原始值記錄但當前是 "-1"，移除它（讓元素恢復默認行為）
            cell.removeAttribute('tabindex');
            console.log('✅ Removed tabindex="-1" from visible gallery-cell #' + cellIndex);
          }
        }
        
        // 處理單元格內的可聚焦元素
        // 當 aria-hidden="true" 時，所有可聚焦元素應該設置 tabindex="-1"
        // 當 aria-hidden="false" 時，移除 tabindex="-1"（恢復正常聚焦）
        // 查找所有可聚焦元素：a[href], button, input, select, textarea, 以及任何有 tabindex 的元素
        const focusableSelectors = [
          'a[href]',
          'button:not([disabled])',
          'input:not([disabled])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          '[tabindex]'
        ];
        const focusableElements = cell.querySelectorAll(focusableSelectors.join(', '));
        
        focusableElements.forEach(function(element) {
          // 跳過已經被標記為不可聚焦的元素（例如已經有 tabindex="-1" 且不是我們設置的）
          const currentTabindex = element.getAttribute('tabindex');
          const isAlreadyNonFocusable = currentTabindex === '-1' && !element.hasAttribute('data-original-tabindex');
          
          if (isHidden) {
            // 如果單元格被隱藏，設置 tabindex="-1" 使元素不可聚焦
            // 保存原始的 tabindex 值（如果存在）
            if (!element.hasAttribute('data-original-tabindex')) {
              if (currentTabindex !== null && currentTabindex !== '-1') {
                // 保存現有的 tabindex（如果不是 "-1"）
                element.setAttribute('data-original-tabindex', currentTabindex);
              } else {
                // 如果沒有 tabindex 或已經是 "-1"，標記為需要移除
                element.setAttribute('data-original-tabindex', '');
              }
            }
            // 設置 tabindex="-1" 使元素不可聚焦
            if (currentTabindex !== '-1') {
              element.setAttribute('tabindex', '-1');
              console.log('✅ Set tabindex="-1" on focusable element in hidden cell #' + cellIndex + ' (' + element.tagName + ')');
            }
          } else {
            // 如果單元格可見，恢復原始的 tabindex
            if (element.hasAttribute('data-original-tabindex')) {
              const originalTabindex = element.getAttribute('data-original-tabindex');
              if (originalTabindex === '') {
                // 如果原始沒有 tabindex，移除它（讓元素恢復默認行為）
                element.removeAttribute('tabindex');
              } else {
                // 恢復原始的 tabindex 值
                element.setAttribute('tabindex', originalTabindex);
              }
              element.removeAttribute('data-original-tabindex');
              console.log('✅ Restored tabindex on focusable element in visible cell #' + cellIndex + ' (' + element.tagName + ')');
            } else if (currentTabindex === '-1') {
              // 如果元素有 tabindex="-1" 但沒有原始值記錄，可能是我們之前設置的
              // 對於可聚焦元素（如 <a>, <button> 等），移除 tabindex 讓它恢復正常
              if (element.tagName === 'A' || element.tagName === 'BUTTON') {
                element.removeAttribute('tabindex');
                console.log('✅ Removed tabindex="-1" from ' + element.tagName + ' in visible cell #' + cellIndex);
              }
            }
          }
        });
      });
  }
  
  // 修復輪播圖的 ARIA 屬性
  function fixSlideshowAccessibility() {
    console.log('#### Fixing slideshow accessibility ####');
    
    // 查找所有使用 Flickity 的輪播圖（包括首頁輪播圖、testimonial 和產品頁面的 gallery）
    const slideshows = document.querySelectorAll('.js-homepage-slideshow, .js-testimonial, .js-product-gallery');
    
    slideshows.forEach(function(slideshow, slideshowIndex) {
      fixGalleryAccessibility(slideshow, 'slideshow #' + slideshowIndex);
    });
    
    // 處理產品頁面的縮略圖導航（單獨的 Flickity 實例）
    const thumbnailNavs = document.querySelectorAll('.product_gallery_nav');
    thumbnailNavs.forEach(function(nav, navIndex) {
      fixGalleryAccessibility(nav, 'thumbnail nav #' + navIndex);
    });
    
    // 通用處理：修復所有帶有 aria-selected 的 gallery-cell（確保沒有遺漏）
    // 這包括所有可能的 gallery-cell，無論它們在哪個容器中
    const allGalleryCells = document.querySelectorAll('.gallery-cell[aria-selected]');
    if (allGalleryCells.length > 0) {
      console.log('🔍 Found ' + allGalleryCells.length + ' gallery-cells with aria-selected, fixing...');
    }
    allGalleryCells.forEach(function(cell) {
      // 如果這個 cell 還沒有被處理過（仍然有 aria-selected）
      if (cell.hasAttribute('aria-selected')) {
        // 移除 aria-selected
        cell.removeAttribute('aria-selected');
        console.log('✅ Removed aria-selected from gallery-cell:', cell.className);
        
        // 設置正確的 ARIA 屬性
        const isSelected = cell.classList.contains('is-selected') || cell.classList.contains('is-nav-selected');
        const isHidden = !isSelected;
        cell.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
        
        if (isSelected) {
          cell.setAttribute('aria-current', 'true');
        } else {
          cell.removeAttribute('aria-current');
        }
        
        // 處理 gallery-cell 元素本身的 tabindex
        const cellTabindex = cell.getAttribute('tabindex');
        if (isHidden) {
          // 如果單元格被隱藏，確保 tabindex="-1"
          if (!cell.hasAttribute('data-original-cell-tabindex')) {
            if (cellTabindex !== null && cellTabindex !== '-1') {
              cell.setAttribute('data-original-cell-tabindex', cellTabindex);
            } else {
              cell.setAttribute('data-original-cell-tabindex', '');
            }
          }
          if (cellTabindex !== '-1') {
            cell.setAttribute('tabindex', '-1');
            console.log('✅ Set tabindex="-1" on hidden orphan gallery-cell');
          }
        } else {
          // 如果單元格可見，恢復原始的 tabindex
          if (cell.hasAttribute('data-original-cell-tabindex')) {
            const originalTabindex = cell.getAttribute('data-original-cell-tabindex');
            if (originalTabindex === '') {
              cell.removeAttribute('tabindex');
            } else {
              cell.setAttribute('tabindex', originalTabindex);
            }
            cell.removeAttribute('data-original-cell-tabindex');
          } else if (cellTabindex === '-1') {
            cell.removeAttribute('tabindex');
          }
        }
        
        // 處理可聚焦元素
        if (!isSelected) {
          const focusableElements = cell.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]');
          focusableElements.forEach(function(element) {
            if (!element.hasAttribute('data-original-tabindex')) {
              const currentTabindex = element.getAttribute('tabindex');
              if (currentTabindex !== null && currentTabindex !== '-1') {
                element.setAttribute('data-original-tabindex', currentTabindex);
              } else {
                element.setAttribute('data-original-tabindex', '');
              }
            }
            if (element.getAttribute('tabindex') !== '-1') {
              element.setAttribute('tabindex', '-1');
            }
          });
        }
      }
    });
    
    // 額外處理：確保所有 gallery-cell 都沒有 aria-selected（即使沒有被選中器找到）
    const allCells = document.querySelectorAll('.gallery-cell');
    allCells.forEach(function(cell) {
      if (cell.hasAttribute('aria-selected')) {
        cell.removeAttribute('aria-selected');
        const isSelected = cell.classList.contains('is-selected') || cell.classList.contains('is-nav-selected');
        const isHidden = !isSelected;
        cell.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
        if (isSelected) {
          cell.setAttribute('aria-current', 'true');
        } else {
          cell.removeAttribute('aria-current');
        }
        
        // 處理 gallery-cell 元素本身的 tabindex
        const cellTabindex = cell.getAttribute('tabindex');
        if (isHidden && cellTabindex !== '-1') {
          if (!cell.hasAttribute('data-original-cell-tabindex')) {
            if (cellTabindex !== null && cellTabindex !== '-1') {
              cell.setAttribute('data-original-cell-tabindex', cellTabindex);
            } else {
              cell.setAttribute('data-original-cell-tabindex', '');
            }
          }
          cell.setAttribute('tabindex', '-1');
        }
        
        console.log('✅ Fixed gallery-cell with aria-selected:', cell.className);
      }
    });
  }
  
  // 監聽 Flickity 的選擇事件
  function setupFlickityListeners() {
    // 檢查 jQuery 是否可用
    if (typeof $ === 'undefined') {
      console.log('⚠️ jQuery not available yet, will retry');
      return;
    }
    
    const slideshows = document.querySelectorAll('.js-homepage-slideshow, .js-testimonial, .js-product-gallery, .product_gallery_nav');
    
    slideshows.forEach(function(slideshow) {
      // 移除舊的監聽器（如果存在）
      $(slideshow).off('select.flickity.accessibility');
      $(slideshow).off('settle.flickity.accessibility');
      
      // 監聽 Flickity 的 select 事件
      $(slideshow).on('select.flickity.accessibility', function() {
        console.log('🎯 Flickity select event triggered');
        setTimeout(fixSlideshowAccessibility, 50);
      });
      
      // 監聽 Flickity 的 settle 事件（動畫完成後）
      $(slideshow).on('settle.flickity.accessibility', function() {
        console.log('🎯 Flickity settle event triggered');
        setTimeout(fixSlideshowAccessibility, 50);
      });
    });
  }
  
  // 使用 MutationObserver 監聽 DOM 變化
  function setupMutationObserver() {
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      
      mutations.forEach(function(mutation) {
        // 檢查是否有新增的節點
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // 檢查是否是輪播圖或包含輪播圖
              if ((node.classList && (
                node.classList.contains('js-homepage-slideshow') || 
                node.classList.contains('js-testimonial') ||
                node.classList.contains('js-product-gallery') ||
                node.classList.contains('product_gallery_nav') ||
                node.classList.contains('gallery-cell')
              )) || (node.querySelector && (
                node.querySelector('.js-homepage-slideshow') || 
                node.querySelector('.js-testimonial') ||
                node.querySelector('.js-product-gallery') ||
                node.querySelector('.product_gallery_nav') ||
                node.querySelector('.gallery-cell')
              ))) {
                console.log('🎯 Found slideshow element:', node);
                shouldCheck = true;
              }
            }
          });
        }
        
        // 檢查屬性變化
        if (mutation.type === 'attributes') {
          const target = mutation.target;
          
          // 優先處理：如果任何 gallery-cell 有 aria-selected，立即修復
          if (target.classList && target.classList.contains('gallery-cell')) {
            if (mutation.attributeName === 'aria-selected' && target.hasAttribute('aria-selected')) {
              // 立即移除 aria-selected
              target.removeAttribute('aria-selected');
              console.log('🎯 Removed aria-selected attribute immediately from:', target.className);
              // 設置正確的 ARIA 屬性
              const isSelected = target.classList.contains('is-selected') || target.classList.contains('is-nav-selected');
              target.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
              if (isSelected) {
                target.setAttribute('aria-current', 'true');
              } else {
                target.removeAttribute('aria-current');
              }
              shouldCheck = true;
            } else if (mutation.attributeName === 'class') {
              // 當 class 變化時，檢查是否有 aria-selected
              if (target.hasAttribute('aria-selected')) {
                target.removeAttribute('aria-selected');
                const isSelected = target.classList.contains('is-selected') || target.classList.contains('is-nav-selected');
                target.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
                if (isSelected) {
                  target.setAttribute('aria-current', 'true');
                } else {
                  target.removeAttribute('aria-current');
                }
                console.log('🎯 Fixed gallery-cell aria-selected after class change');
              }
              shouldCheck = true;
            }
          } else if (target.classList && target.classList.contains('flickity-enabled')) {
            // Flickity 容器變化時，觸發完整檢查
            if (mutation.attributeName === 'class') {
              console.log('🎯 Flickity container changed');
              shouldCheck = true;
            }
          }
        }
      });
      
      // 無論如何都執行快速修復
      quickFixAriaSelected();
      
      if (shouldCheck) {
        setTimeout(function() {
          fixSlideshowAccessibility();
          setupFlickityListeners();
        }, 100);
      }
    });
    
    // 開始觀察整個 document body
    if (document.body) {
      console.log('👀 Starting MutationObserver for slideshow');
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-selected', 'class', 'aria-hidden', 'aria-current']
      });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        console.log('👀 Starting MutationObserver for slideshow (after DOMContentLoaded)');
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-selected', 'class', 'aria-hidden']
        });
      });
    }
  }
  
  // 快速修復函數：專門用於移除 aria-selected
  function quickFixAriaSelected() {
    const cellsWithAriaSelected = document.querySelectorAll('.gallery-cell[aria-selected]');
    if (cellsWithAriaSelected.length > 0) {
      console.log('🔍 Quick fix: Found ' + cellsWithAriaSelected.length + ' cells with aria-selected, fixing...');
      cellsWithAriaSelected.forEach(function(cell) {
        cell.removeAttribute('aria-selected');
        const isSelected = cell.classList.contains('is-selected') || cell.classList.contains('is-nav-selected');
        cell.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
        if (isSelected) {
          cell.setAttribute('aria-current', 'true');
        } else {
          cell.removeAttribute('aria-current');
        }
        console.log('✅ Quick fixed gallery-cell:', cell.className);
      });
      return true; // 表示有修復
    }
    return false; // 表示沒有需要修復的
  }
  
  // 定期檢查並修復 aria-selected（確保 Flickity 動態添加的屬性也被修復）
  function startPeriodicCheck() {
    // 每 200ms 檢查一次，持續 15 秒（75次檢查）
    let checkCount = 0;
    const maxChecks = 75;
    const checkInterval = setInterval(function() {
      checkCount++;
      const fixed = quickFixAriaSelected();
      
      if (checkCount >= maxChecks) {
        clearInterval(checkInterval);
        console.log('✅ Periodic check completed after ' + maxChecks + ' checks');
        // 即使定期檢查結束，也設置一個較慢的長期檢查（每 2 秒一次）
        setInterval(quickFixAriaSelected, 2000);
      }
    }, 200);
  }
  
  // 初始化函數
  function init() {
    console.log('🚀 Initializing Slideshow Accessibility Fix');
    
    // 設置 MutationObserver
    setupMutationObserver();
    
    // 立即執行一次
    console.log('🚀 Initial check');
    fixSlideshowAccessibility();
    setupFlickityListeners();
    
    // 開始定期檢查
    startPeriodicCheck();
    
    // 延遲執行，確保覆蓋所有情況
    console.log('⏰ Scheduling delayed checks');
    setTimeout(function() {
      console.log('⏰ Delayed check 1 (500ms)');
      fixSlideshowAccessibility();
      setupFlickityListeners();
    }, 500);
    
    setTimeout(function() {
      console.log('⏰ Delayed check 2 (1000ms)');
      fixSlideshowAccessibility();
      setupFlickityListeners();
    }, 1000);
    
    setTimeout(function() {
      console.log('⏰ Delayed check 3 (2000ms)');
      fixSlideshowAccessibility();
      setupFlickityListeners();
    }, 2000);
    
    setTimeout(function() {
      console.log('⏰ Delayed check 4 (3000ms)');
      fixSlideshowAccessibility();
      setupFlickityListeners();
    }, 3000);
    
    setTimeout(function() {
      console.log('⏰ Delayed check 5 (5000ms)');
      fixSlideshowAccessibility();
      setupFlickityListeners();
    }, 5000);
    
    console.log('✅ Slideshow Accessibility Fix: Script initialized');
  }
  
  // 根據 DOM 狀態決定何時執行
  if (document.readyState === 'loading') {
    console.log('📋 Document is loading, waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', init);
  } else {
    console.log('📋 Document already loaded, initializing immediately');
    if (document.body) {
      init();
    } else {
      setTimeout(function() {
        if (document.body) {
          init();
        } else {
          console.log('⚠️ Still no body, waiting for window load');
          window.addEventListener('load', init);
        }
      }, 100);
    }
  }
  
  // 監聽 window load 事件作為備用
  window.addEventListener('load', function() {
    console.log('📦 Window loaded, checking slideshow again');
    setTimeout(function() {
      fixSlideshowAccessibility();
      setupFlickityListeners();
    }, 1000);
  });
  
  // 等待 jQuery 和 Flickity 加載
  function waitForDependencies() {
    if (typeof $ !== 'undefined' && typeof $.fn !== 'undefined' && typeof $.fn.flickity !== 'undefined') {
      console.log('📦 jQuery and Flickity loaded');
      setTimeout(function() {
        fixSlideshowAccessibility();
        setupFlickityListeners();
      }, 500);
      return true;
    }
    return false;
  }
  
  // 如果依賴已經加載，立即執行
  if (!waitForDependencies()) {
    // 否則等待 window load 事件
    let checkCount = 0;
    const maxChecks = 20; // 最多檢查 20 次（10 秒）
    const checkInterval = setInterval(function() {
      checkCount++;
      if (waitForDependencies() || checkCount >= maxChecks) {
        clearInterval(checkInterval);
      }
    }, 500);
  }
})();
